export default __webpack_public_path__ + "static/media/pet-health.dae477bb.mp4";